
interface FormatPriceOptions {
  locale?: string
  currency?: string
  showSign?: boolean
}

export const formatPrice = (amount: number | undefined, options?: FormatPriceOptions): string => {
  if (amount === undefined) {
    return ''
  }

  const locale = options?.locale ?? window.directBilling?.env?.locale ?? 'en-ca'
  const currency = options?.currency ?? window.directBilling?.env?.currency ?? 'CAD'
  const signDisplay = options?.showSign === true ? 'always' : (options?.showSign === false ? 'never' : undefined)

  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    signDisplay,
  }).format(amount)
}

export const roundPrice = (value: number): number => {
  const num = Math.round( ( value + Number.EPSILON ) * 100 ) / 100
  return Number(num.toFixed(2))
}